"use client";
import { Grid2 } from "@repo/ui";
import WebinarCardLoader from "./WebinarCardLoader";

const WebinarsLoader = () => {
  return (
    <Grid2 container spacing={5} role="status">
      <Grid2 size={{ sm: 1, md: 4, lg: 4 }}>
        <WebinarCardLoader />
      </Grid2>
      <Grid2 size={{ sm: 1, md: 4, lg: 4 }}>
        <WebinarCardLoader />
      </Grid2>
      <Grid2 size={{ sm: 1, md: 4, lg: 4 }}>
        <WebinarCardLoader />
      </Grid2>
      <Grid2 size={{ sm: 1, md: 4, lg: 4 }}>
        <WebinarCardLoader />
      </Grid2>
      <Grid2 size={{ sm: 1, md: 4, lg: 4 }}>
        <WebinarCardLoader />
      </Grid2>
      <Grid2 size={{ sm: 1, md: 4, lg: 4 }}>
        <WebinarCardLoader />
      </Grid2>
      <span className="sr-only">Loading...</span>
    </Grid2>
  );
};

export default WebinarsLoader;
